import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledDropdown = styled('div')`
  .dropdown-container {
    display: flex;
    width: ${(props) => props.metaData?.width};
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    gap: ${(props) => props.metaData?.gap};
    padding: ${(props) => props.metaData?.padding};
    border: ${(props) => props.metaData?.border};
    border-radius: 8px;
    cursor: pointer;
    height: ${(props) => props.metaData?.height};
    box-sizing: border-box;
    &:hover {
      background-color: ${COLOR.backgroundLinearProgress};
    }
    .dropdown-title {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &.disabled {
      pointer-events: auto;
      cursor: not-allowed !important;
      opacity: 0.5;
    }
    @media (max-width: 1170px) {
      width: 100%;
    }
  }
`;

export const StyledSortVoiceFilterButton = styled('div')`
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px ${COLOR.boxShadow};
  padding: 8px;
  box-sizing: border-box;
  width: 225px;
  .item {
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    box-sizing: border-box;
    border-radius: 8px;
    cursor: pointer;
    width: 100%;
    display: flex;
    gap: 10px;
    &:hover {
      color: ${COLOR.text};
      background-color: ${TRANSPARENT_COLOR.dark};
    }
  }
`;
